import { useState } from 'react'
import {
  HiOutlinePlus,
  HiOutlineLocationMarker,
  HiOutlineX,
  HiOutlineMap,
  HiOutlinePencilAlt,
  HiOutlineZoomIn,
} from 'react-icons/hi'
import clsx from 'clsx'

function MobileMapFAB({
  onAddMarker,
  onMyLocation,
  onDrawPath,
  isAddingMarker = false,
  disabled = false,
}) {
  const [isExpanded, setIsExpanded] = useState(false)

  const menuItems = [
    {
      id: 'marker',
      icon: HiOutlineLocationMarker,
      label: 'Thêm marker',
      color: 'bg-primary-500',
      onClick: () => {
        setIsExpanded(false)
        onAddMarker?.()
      },
    },
    {
      id: 'location',
      icon: HiOutlineMap,
      label: 'Vị trí của tôi',
      color: 'bg-emerald-500',
      onClick: () => {
        setIsExpanded(false)
        onMyLocation?.()
      },
    },
    {
      id: 'draw',
      icon: HiOutlinePencilAlt,
      label: 'Vẽ đường',
      color: 'bg-purple-500',
      onClick: () => {
        setIsExpanded(false)
        onDrawPath?.()
      },
      disabled: true, // Coming soon
    },
  ]

  // If adding marker, show cancel button instead
  if (isAddingMarker) {
    return (
      <div className="fixed right-4 bottom-28 z-40 md:hidden">
        <button
          onClick={onAddMarker}
          className="w-14 h-14 rounded-full bg-red-500 text-white shadow-lg flex items-center justify-center active:scale-95 transition-transform"
        >
          <HiOutlineX className="w-6 h-6" />
        </button>
        <span className="absolute -top-8 right-0 whitespace-nowrap text-xs bg-gray-900 text-white px-2 py-1 rounded-lg">
          Tap để hủy
        </span>
      </div>
    )
  }

  return (
    <div className="fixed right-4 bottom-28 z-40 md:hidden">
      {/* Menu items */}
      <div
        className={clsx(
          'absolute bottom-16 right-0 space-y-2 transition-all duration-300',
          isExpanded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        )}
      >
        {menuItems.map((item, index) => (
          <div
            key={item.id}
            className="flex items-center justify-end gap-2"
            style={{
              transitionDelay: isExpanded ? `${index * 50}ms` : '0ms',
            }}
          >
            <span className="px-3 py-1.5 bg-gray-900 text-white text-sm rounded-lg whitespace-nowrap shadow-lg">
              {item.label}
            </span>
            <button
              onClick={item.onClick}
              disabled={item.disabled || disabled}
              className={clsx(
                'w-12 h-12 rounded-full text-white shadow-lg flex items-center justify-center transition-all',
                item.disabled ? 'bg-gray-400 opacity-50' : item.color,
                'active:scale-95'
              )}
            >
              <item.icon className="w-5 h-5" />
            </button>
          </div>
        ))}
      </div>

      {/* Main FAB button */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        disabled={disabled}
        className={clsx(
          'w-14 h-14 rounded-full shadow-xl flex items-center justify-center transition-all',
          isExpanded
            ? 'bg-gray-900 rotate-45'
            : 'bg-primary-600 hover:bg-primary-700',
          'active:scale-95',
          disabled && 'opacity-50'
        )}
      >
        <HiOutlinePlus className="w-7 h-7 text-white" />
      </button>

      {/* Backdrop when expanded */}
      {isExpanded && (
        <div
          className="fixed inset-0 z-[-1]"
          onClick={() => setIsExpanded(false)}
        />
      )}
    </div>
  )
}

export default MobileMapFAB
